import { api } from "./axios";


export interface ExclusivePermissionGrant {
  permissionId: number;
  limit: number | null;
}

export const exclusivePermissionApi = {
  getUsersWithExclusivePermissions: ({
    page = 1,
    limit = 10,
    search = "",
  }: {
    page?: number;
    limit?: number;
    search?: string;
  } = {}) =>
    api.get("/admin/get-users-with-exclusive-permissions", {
      params: { page, limit, search },
    }),

  getUserPermissions: (userId: number | string) =>
    api.get(`/admin/users/${userId}/permissions`),

  grantPermissions: (
    userId: number | string,
    exclusivePermissions: ExclusivePermissionGrant[],
  ) => api.post(`/admin/users/${userId}/permissions`, { exclusivePermissions }),

  updatePermissions: (
    userId: number | string,
    updatedData: ExclusivePermissionGrant[],
  ) => api.put(`/admin/users/${userId}/permissions`, { updatedData }),

  revokeAllPermissions: (userId: number | string) =>
    api.delete(`/admin/users/${userId}/permissions`),
};
